import { render, staticRenderFns } from "./CRDPoolsForm.vue?vue&type=template&id=3143d846&scoped=true&"
import script from "./CRDPoolsForm.vue?vue&type=script&lang=js&"
export * from "./CRDPoolsForm.vue?vue&type=script&lang=js&"
import style0 from "./CRDPoolsForm.vue?vue&type=style&index=0&id=3143d846&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3143d846",
  null
  
)

export default component.exports